import {
  CHANGE_LANGUAGE,
  JOB_FAMILIES_DETAILS_SUCCESS,
  ACTIVITY_GROUP_DETAILS_SUCCESS,
  EXCEPTIONS_DETAILS_SUCCESS,
  LOCATIONS_DETAILS_SUCCESS,
  PUNCH_ENTRY_LOADING,
  COUNTRY_DETAILS_SUCCESS,
  MANAGER_EMAIL_LOOKUP_SUCCESS,
  MANAGER_COST_CENTER_DATA_SUCCESS,
  SELECTED_WORKER_ON_REVIEW,
  SELECTED_WEEK_ON_REVIEW,
  SELECTED_MANAGER_ON_REVIEW,
  SELECTED_TEAM_ON_REVIEW,
  SELECTED_MONTH_ON_REPORT,
  DSC_LOAD_LOCATIONS_DATA,
  DSC_DRAWER_STATE,
  PROJECT_DETAILS_BYCOUNTRY,
  PROJECTS_DETAILS_SUCCESS,
  MANAGE_WORKERS_FILTERS_LIST,
  REPORT_VIEW_FILTERS_LIST,
  ALL_PUNCH_VIEW_FILTERS_LIST,
  MANAGE_ACTIVITY_GROUP_FILTERS_LIST,
  SAVE_DEVICE_LOCATION,
  SET_DASHBOARD_DISTRICTS,
  SET_DASHBOARD_BUILDINGS,
  SET_DASHBOARD_MANAGER,
  TRANSPORT_DETAILS_FILTERS_LIST,
  SET_DASHBOARD_APH_DISTRICT,
  WORKDAY_CONFIG_SUCCESS
} from "../CONSTANTS";

const initialState = {
  isOnline: true,
  language: "",
  jobFamilies: null,
  activityGroups: null,
  locations: null,
  countries: null,
  managerEmails: null,
  managerCostCenterData:null,
  selectedWorkerOnReview: null,
  selectedWeekOnReview: null,
  selectedManagerForApproval: null,
  selectedTeamOnReview: null,
  locationsDev: [],
  dscDrawerOpen: false,
  projectDetailsByCountry: [],
  projects: null,
  deviceCountry: null,
  manageWorkersFiltersData: [[], [], [], [], [], [], [], []],
  reportViewFiltersData: [
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
  ],
  allPunchViewFiltersData: [
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
  ],
  manageActivityGroupFiltersData: [[], [], [], [], [], []],
  dashboardDistricts: [],
  dashboardBuildings: [],
  dashboardManager:{},
  dashboardAphDistrict:[],
  transportDetalisFiltersData:[
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    []
  ],
  workdayConfig:{}
};

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      console.log("appReducer > CHANGE_LANGUAGE...");
      return {
        ...state,
        language: action.payload,
      };
    case JOB_FAMILIES_DETAILS_SUCCESS:
      console.log("appReducer > JOB_FAMILIES_DETAILS_SUCCESS...");
      return {
        ...state,
        jobFamilies: action.payload,
      };
    case ACTIVITY_GROUP_DETAILS_SUCCESS:
      console.log("appReducer > ACTIVITY_GROUP_DETAILS_SUCCESS...");
      return {
        ...state,
        activityGroups: action.payload,
      };
    case EXCEPTIONS_DETAILS_SUCCESS:
      console.log("appReducer > EXCEPTIONS_DETAILS_SUCCESS...");
      return {
        ...state,
        exceptions: action.payload,
      };
    case LOCATIONS_DETAILS_SUCCESS:
      console.log("appReducer > LOCATIONS_DETAILS_SUCCESS...");
      return {
        ...state,
        loading: false,
        locations: { ...state.locations, ...action.payload },
      };
    case PROJECTS_DETAILS_SUCCESS:
      console.log("appReducer > PROJECTS_DETAILS_SUCCESS...");
      return {
        ...state,
        projects: action.payload,
      };
    case PUNCH_ENTRY_LOADING:
      console.log("appReducer > PUNCH_ENTRY_LOADING...");
      return {
        ...state,
        loading: true,
      };
    case COUNTRY_DETAILS_SUCCESS:
      console.log("appReducer > COUNTRY_DETAILS_SUCCESS...");
      return {
        ...state,
        countries: action.payload,
      };
    case MANAGER_EMAIL_LOOKUP_SUCCESS:
      console.log("appReducer > MANAGER_EMAIL_LOOKUP_SUCCESS...");
      return {
        ...state,
        managerEmails: action.payload,
      };
    case MANAGER_COST_CENTER_DATA_SUCCESS:
      console.log("appReducer > MANAGER_COST_CENTER_DATA_SUCCESS...");
      return {
        ...state,
        managerCostCenterData: action.payload,
      }; 

    case WORKDAY_CONFIG_SUCCESS:
      console.log("appReducer > WORKDAY_CONFIG_SUCCESS...");
      return {
        ...state,
        workdayConfig : action.payload
      }

    case SELECTED_WORKER_ON_REVIEW:
      console.log(
        "SELECTED_WORKER_ON_REVIEW :",
        SELECTED_WORKER_ON_REVIEW,
        action.payload
      );
      return {
        ...state,
        selectedWorkerOnReview: action.payload,
      };

    case SELECTED_WEEK_ON_REVIEW:
      console.log(
        "SELECTED_WEEK_ON_REVIEW :",
        SELECTED_WEEK_ON_REVIEW,
        action.payload
      );
      return {
        ...state,
        selectedWeekOnReview: action.payload,
      };

    case SELECTED_MANAGER_ON_REVIEW:
      console.log(
        "SELECTED_MANAGER_ON_REVIEW :",
        SELECTED_MANAGER_ON_REVIEW,
        action.payload
      );
      return {
        ...state,
        selectedManagerForApproval: action.payload,
      };

    case SELECTED_TEAM_ON_REVIEW:
      console.log(
        "SELECTED_TEAM_ON_REVIEW :",
        SELECTED_TEAM_ON_REVIEW,
        action.payload
      );
      return {
        ...state,
        selectedTeamOnReview: action.payload,
      };

    case SELECTED_MONTH_ON_REPORT:
      console.log(
        "SELECTED_MONTH_ON_REPORT :",
        SELECTED_MONTH_ON_REPORT,
        action.payload
      );
      return {
        ...state,
        selectedMonthOnReport: action.payload,
      };
    case DSC_LOAD_LOCATIONS_DATA:
      console.log(
        "DSC_LOAD_LOCATIONS_DATA :",
        DSC_LOAD_LOCATIONS_DATA,
        action.payload
      );
      return {
        ...state,
        locationsDev: action.payload,
      };
    case DSC_DRAWER_STATE:
      console.log("DSC_DRAWER_STATE :", DSC_DRAWER_STATE, action.payload);
      return {
        ...state,
        dscDrawerOpen: action.payload,
      };
    case PROJECT_DETAILS_BYCOUNTRY:
      console.log(
        "PROJECT_DETAILS_BYCOUNTRY",
        PROJECT_DETAILS_BYCOUNTRY,
        action.payload
      );
      return {
        ...state,
        projectDetailsByCountry: action.payload,
      };

    case MANAGE_WORKERS_FILTERS_LIST:
      console.log(
        "MANAGE_WORKERS_FILTERS_LIST :",
        MANAGE_WORKERS_FILTERS_LIST,
        action.payload
      );
      return {
        ...state,
        manageWorkersFiltersData: action.payload,
      };
    case REPORT_VIEW_FILTERS_LIST:
      console.log(
        "REPORT_VIEW_FILTERS_LIST :",
        REPORT_VIEW_FILTERS_LIST,
        action.payload
      );
      return {
        ...state,
        reportViewFiltersData: action.payload,
      };
    case TRANSPORT_DETAILS_FILTERS_LIST:
      return {
        ...state,
        transportDetalisFiltersData : action.payload
      }  
    case ALL_PUNCH_VIEW_FILTERS_LIST:
      console.log(
        "ALL_PUNCH_VIEW_FILTERS_LIST :",
        ALL_PUNCH_VIEW_FILTERS_LIST,
        action.payload
      );
      return {
        ...state,
        allPunchViewFiltersData: action.payload,
      };
    case MANAGE_ACTIVITY_GROUP_FILTERS_LIST:
      console.log(
        "MANAGE_ACTIVITY_GROUP_FILTERS_LIST :",
        MANAGE_ACTIVITY_GROUP_FILTERS_LIST,
        action.payload
      );
      return {
        ...state,
        manageActivityGroupFiltersData: action.payload,
      };

    case SAVE_DEVICE_LOCATION:
      console.log(
        "SAVE_DEVICE_LOCATION :",
        SAVE_DEVICE_LOCATION,
        action.payload
      );
      return {
        ...state,
        deviceCountry: action.payload,
      };

    case SET_DASHBOARD_DISTRICTS:
      return {
        ...state,
        dashboardDistricts: action.payload,
      };

    case SET_DASHBOARD_BUILDINGS:
      return {
        ...state,
        dashboardBuildings: action.payload,
      };

    case SET_DASHBOARD_APH_DISTRICT:
      return {
        ...state,
        dashboardAphDistrict: action.payload,
      };
    
    case SET_DASHBOARD_MANAGER:
      return{
        ...state,
        dashboardManager:action.payload
      }

    default:
      return state;
  }
};

export default appReducer;
